export const kebabCaseToCamelCase = (value) => {
    return value.replace(/([-][a-z])/gi, (group) => group.toUpperCase().replace("-", ""));
};
export const snakeCaseToCamelCase = (value) => {
    return value.replace(/([_][a-z])/gi, (group) => group.toUpperCase().replace("_", ""));
};
export const camelCaseToSnakeCase = (value) => {
    return value.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? "_" : "") + match.toLowerCase());
};
export const pascalCaseToCamelCase = (value) => {
    return `${value[0].toLowerCase()}${value.substr(1, value.length)}`;
};
export const camelCaseToPascalCase = (value) => {
    return `${value[0].toUpperCase()}${value.substr(1, value.length)}`;
};
export const getFormattedMessageWithLineBreaks = (value) => {
    return value.replace(/\n/g, "<br />");
};
export const truncateString = (value, end) => {
    return value?.length > end ? `${value.substring(0, end)}...` : value;
};
export const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};
export const lowercaseFirst = (text) => (text ? text.charAt(0).toLowerCase() + text.slice(1) : text);
// Remove circular dependencies from an object before stringifying it.
export const stringify = (obj) => {
    const cache = [];
    const str = JSON.stringify(obj, (_key, value) => {
        if (typeof value === "object" && value !== null) {
            if (cache.includes(value)) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
        return value;
    });
    // Reset the cache
    cache.length = 0;
    return str;
};
export const decodeHTMLEntities = (input) => input.replace(/&amp;/g, "&");
const NAMED_HTML_ENTITIES = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
    nbsp: " ",
    ndash: "–",
    mdash: "—",
    hellip: "…",
    lsquo: "\u2018",
    rsquo: "\u2019",
    ldquo: "\u201C",
    rdquo: "\u201D",
    laquo: "«",
    raquo: "»",
    eacute: "é",
    egrave: "è",
    ecirc: "ê",
    agrave: "à",
    acirc: "â",
    ccedil: "ç",
    ocirc: "ô",
    ucirc: "û",
    ugrave: "ù",
    icirc: "î",
    copy: "©",
    reg: "®",
    trade: "™",
};
function decodeNumericEntity(codePoint, fallback) {
    const isValidCodePoint = Number.isInteger(codePoint) &&
        codePoint >= 0 &&
        codePoint <= 0x10ffff &&
        !(codePoint >= 0xd800 && codePoint <= 0xdfff);
    return isValidCodePoint ? String.fromCodePoint(codePoint) : fallback;
}
export function decodeHtmlEntities(text) {
    return text.replace(/&(#x?[0-9a-fA-F]+|[a-zA-Z]+);/g, (match, entity) => {
        if (entity.startsWith("#x") || entity.startsWith("#X")) {
            return decodeNumericEntity(Number.parseInt(entity.slice(2), 16), match);
        }
        if (entity.startsWith("#")) {
            return decodeNumericEntity(Number.parseInt(entity.slice(1), 10), match);
        }
        return NAMED_HTML_ENTITIES[entity.toLowerCase()] ?? match;
    });
}
export const escapeHtml = (value) => value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
export const hasAtLeastNDigitCharacters = (value, n) => Boolean(value.match(new RegExp(`(\\D*\\d){${n},}`, "g"))?.length);
/**
 * Normalizes a string by removing accents/diacritics for comparison purposes.
 * Converts "Québec" to "Quebec", "Montréal" to "Montreal", etc.
 */
export const normalizeAccents = (str) => {
    if (!str) {
        return "";
    }
    return str
        .normalize("NFD") // Decompose characters into base + combining characters
        .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritical marks
        .toLowerCase()
        .trim();
};
